// extracted by mini-css-extract-plugin
export default {"statistic":"style_statistic__sbxUL","statistic_item":"style_statistic_item__CmzLr","statistic_number":"style_statistic_number__4SSc6","statistic_text":"style_statistic_text__2XZj8"};